export default function imageMap(image): App.Image {
  return {
    id: image.id_cloudinary_external || image.id,
    title: image.title,
  }
}
